// extracted by mini-css-extract-plugin
module.exports = {"descriptions":"descriptions--3Smt_","download-button":"download-button--2CIYY","downloadButton":"download-button--2CIYY"};